import { Component } from '@angular/core';

@Component({
  selector: 'dashboard',
  styleUrls: ['./dashboard.scss'],
  templateUrl: './dashboard.html'
})
export class Dashboard {

  constructor() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/dashboard/dashboard.component.ts